<div class="field" *ngIf="value != null">
    <span id="money-factor" class="value" translate="moneyFactor"  [translateParams]="{moneyFactor: value | localeMoneyFactor}"></span>
</div>

